import React from 'react';

export const ShieldSpot = (): React.ReactElement => (
  <svg fill="none" height="56" width="56" xmlns="http://www.w3.org/2000/svg">
    <circle cx="28.302" cy="28.057" fill="#F7F5F0" r="27.678" />
    <path
      d="M28.111 44.004a2.31 2.31 0 0 1-.763-.135c-2.138-.748-9.345-3.709-12.033-9.976-2-4.666-1.786-12.309-1.527-15.375 0-1.33 1.329-1.824 1.94-2.049 2.61-1.002 9.162-3.619 11.345-4.815a2.337 2.337 0 0 1 2.2 0c2.229 1.196 8.688 3.799 11.284 4.8a2.535 2.535 0 0 1 1.954 2.05c.184 3.066.397 10.708-1.603 15.374-2.687 6.267-9.849 9.213-11.972 9.976a2.252 2.252 0 0 1-.824.15z"
      fill="#38AF88"
    />
    <path
      d="M28.124 44.004V11.379c.537.06.92.152 1.148.275 2.23 1.196 8.689 3.799 11.285 4.8a2.535 2.535 0 0 1 1.954 2.05c.184 3.066.397 10.708-1.603 15.374-2.687 6.267-9.849 9.213-11.972 9.976-.174.068-.445.117-.812.15z"
      fill="#184634"
    />
    <path
      d="M20.343 26.163c.676-.676 1.8-.66 2.572.015l.108.101 3.494 3.495 7.691-7.69c.676-.675 1.8-.658 2.572.017l.108.1c.737.737.818 1.864.208 2.58l-.092.1-8.971 8.971c-.676.676-1.8.66-2.572-.015l-.108-.101-4.893-4.893c-.773-.773-.825-1.973-.117-2.68z"
      fill="#fff"
    />
  </svg>
);
